import {
  DEFAULT_FILTER_TYPES,
  defaultFilters
} from '@/compositions/filter.helpers';

export const GEOZONE_LIST_FILTER = 'GEOZONE_LIST_FILTER';

export function useGeozoneFilters() {
  return [
    defaultFilters[DEFAULT_FILTER_TYPES.STATUS],
    defaultFilters[DEFAULT_FILTER_TYPES.COLORS]
  ];
}
